import { getDateWithSpecificFormat } from "../../../../data-transform";
const islegalEntityAvailable = (fieldData) => {
    if(fieldData.legalEntityList[0]?.legalEntityId) {
        return true;
    } else {
        return false;
    
    }
}

export default function createCustomerEntityDetailColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((fieldData, rowIndex) => {

        let row = [];
        const rowId = config.tableType;

        config.columns.forEach((column, columnIndex) => {
            const columnId = column.id;
            let columnDataType = column.data.displayInBodyAs;
            let columnValue = null;
            let columnValueData = null;

            if (columnDataType === "string") {
                if (columnId === "customerEntityCreationDate") {
                    columnValue = getDateWithSpecificFormat(fieldData.createdDate) || "";
                }
            }
            if (columnDataType === "input") {
                if (columnId === 'companyName') {
                    if(islegalEntityAvailable(fieldData)){
                        columnDataType ="string";
                        columnValue = fieldData.companyName || "";
                    }else {
                        columnValueData = { ...column.data };
                        columnValue = fieldData.companyName || "";
                        columnValueData.defaultValue = columnValue;
                    }
                }
                else if (columnId === 'orgId') {
                    if(islegalEntityAvailable(fieldData)){
                        columnDataType ="string";
                        columnValue = fieldData.orgId;
                    } else {
                        columnValueData = { ...column.data };
                        columnValue = fieldData.orgId;
                        columnValueData.defaultValue = columnValue;                        
                    }
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId + "!" + rowIndex + "" + columnIndex,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    displayAsIs: column.data.displayInBodyAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: column.data.highlightBodyText,
                    clickHandler: event => columnDataType !== "string" && config.bodyButtonsHandler(event, columnId, rowIndex)
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}
